<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="financialKnowledgeLevel"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="knowledgeFinancialOptions"
            label="Quelle est votre connaissance des marchés financiers ?"
          >
          </pr-input-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="frequencyFinancialTransactions"
            direction="column"
            [isDefault]="false"
            columns="4"
            [options]="frequencyFinancialOptions"
            label="Fréquence moyenne de vos opérations financières ?"
          >
          </pr-input-radio>
        </div>

        <div class="col-md-12">
          <pr-input-column
            label="Nombre d'opérations effectuées sur les 12 derniers mois"
            [derrors]="derrors"
            [isDefault]="false"
          >
            <input formControlName="numberTransactionsLastYear" type="number" />
          </pr-input-column>
        </div>
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
